// extracted by mini-css-extract-plugin
module.exports = {"app":"Keyboard_app__WA_3W","blurred":"Keyboard_blurred___t0P0","scanner":"Keyboard_scanner__yVKXF","keyboard":"Keyboard_keyboard__3KnjD","open":"Keyboard_open__3I3s8"};